export var productTileFavoritePropsILeanProductTileAdapter = function(productTile) {
    var _productTile_product, _productTile_product1, _productTile_product2, _productTile_product3, _productTile_product4;
    return {
        productToken: (_productTile_product = productTile.product) === null || _productTile_product === void 0 ? void 0 : _productTile_product.token,
        hide: !productTile.product,
        bestImage: productTile.best_image,
        boardTokens: (_productTile_product1 = productTile.product) === null || _productTile_product1 === void 0 ? void 0 : _productTile_product1.board_tokens,
        brandToken: (_productTile_product2 = productTile.product) === null || _productTile_product2 === void 0 ? void 0 : _productTile_product2.brand_token,
        impressionId: (_productTile_product3 = productTile.product) === null || _productTile_product3 === void 0 ? void 0 : _productTile_product3.impression_id,
        promotedBy: (_productTile_product4 = productTile.product) === null || _productTile_product4 === void 0 ? void 0 : _productTile_product4.promoted_by
    };
};
